import {
  styled,
  Stepper,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  stepLabelClasses,
  Box,
} from '@mui/material';

export const StepperOrderStateStepper = styled(Stepper)({
  maxWidth: '100%',
});

export const StepperOrderStateStepConnector = styled(StepConnector)(
  ({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    padding: '4px 0',

    [`& .${stepConnectorClasses.line}`]: {
      height: 5,
      border: 0,
      backgroundColor: theme.palette.common.white,
      borderRadius: 1,
    },

    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: theme.palette.primary.main,
      },
    },

    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: theme.palette.primary.main,
      },
    },
  }),
);

export const StepperOrderStateStep = styled(Step)({
  padding: 0,
});

export const StepperOrderStateStepLabel = styled(StepLabel)({
  [`& .${stepLabelClasses.iconContainer}`]: {
    padding: 0,
  },
});

export const StepperOrderStateStepIconContainer = styled(Box)<{
  ownerState: { isActive?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.common.white,
  width: 60,
  height: 60,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',

  ...(ownerState.isActive && {
    '&:before, &:after': {
      content: '""',
      boxShadow: `0 0 0 0 ${theme.palette.primary.main}`,
      opacity: 0.7,
      animation: 'pulseKeyFrames 1.3s infinite',
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: 'inherit',
    },

    '&:after': {
      animationDelay: '0.3s',
    },

    '@keyframes pulseKeyFrames': {
      '100%': {
        boxShadow: `0 0 0 10px currentColor`,
        opacity: 0,
      },
    },
  }),
}));

export const StepperOrderStateStepIconBoxStatus = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.tertiary.main,
  color: theme.palette.common.white,
  width: 42,
  height: 42,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',

  ...(ownerState.active && {
    backgroundColor: theme.palette.primary.main,
  }),

  ...(ownerState.completed && {
    backgroundColor: theme.palette.primary.main,
  }),
}));
